<template>
  <div class="notification-wrapper" v-if="notificationList">
    <template v-if="notificationList.length > 0">
      <div class="banner-wrapper">
        <img :src="notificationList[0].image">
      </div>
      <div class="article-wrapper">
        <div class="header">
          最新消息
        </div>
        <div class="title">
            {{ notificationList[0].title }}
        </div>
        <div class="bottom-wrapper">
          <div class="content" v-html="notificationList[0].content">
          </div>
          <div class="button-wrapper">
            <b-button variant="primary" @click="goToEdit(notificationList[0].id)">了解更多</b-button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="article-wrapper">
        <div class="header">
          最新消息
        </div>
        <div class="title">
          最新消息
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue';

export default {
  components: {
    BButton,
  },
  props: {
    role: String,
    loading: String,
    notificationList: Array,
  },
  data: () => ({
    activeSlideId: 0,
  }),
  methods: {
    goToEdit(id) {
      this.$router.push({
        path: `notification/${id}`,
      });
    },
    onSlideChange(slider) {
      this.activeSlideId = slider.realIndex;
    },
  },
  computed: {
    activeNotificationId() {
      return this.notificationList[this.activeSlideId].id;
    },
  },
};
</script>

<style scoped lang="scss">
.notification-wrapper {
  width: 60%;
  margin-right: 15px;
  display: flex;
  height: 288px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #dde1e5;
  @include respond(tab-landscape) {
    width: 100%;
    margin: 0px;
    flex-direction: column;
    height: auto;
    margin-bottom: 15px;
  }
  .banner-wrapper {
    width: 55%;
    @include respond(tab-landscape) {
      width: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .article-wrapper {
    width: 45%;
    padding: 15px;
    box-sizing: border-box;
    position: relative;
    @include respond(tab-landscape) {
      width: 100%;
    }
    .header {
      font-size: 18px;
      color: #174169;
      max-height: 26.5px;
      margin-bottom: 10px;
    }
    .title {
      font-size: 16px;
      color: #302E2E;
      max-height: 48px;
      overflow: hidden;
      margin-bottom: 10px;
      word-wrap: break-word;
    }
    .bottom-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 165px;
      @include respond(tab-landscape) {
        height: auto;
      }
      .content {
        color: #696969;
        max-height: 85px;
        font-size: 14px;
        overflow: hidden;
        word-wrap: break-word;
      }
      .button-wrapper {
        text-align: right;
        @include respond(tab-landscape) {
          text-align: center;
          height: auto;
        }
        button {
          @include respond(tab-landscape) {
            width: 215px;
            position: inherit;
          }
          position: absolute;
          bottom: 25px;
          right: 15px;
          display: inline-block;
          width: 112px;
        }
      }
    }
  }
}
</style>
